import { Link } from "react-router-dom";
import { AlertTriangle } from "lucide-react";
import { formatDatePretty } from "../../lib/progress";

export function PendingMakeupBanner({ pendingMakeups }) {
    if (!pendingMakeups || pendingMakeups.length === 0) return null;

    return (
        <div
            className="bg-warning-soft border border-warning/30 rounded-3xl px-5 sm:px-6 py-4 flex items-center gap-3"
            data-testid="pending-makeup-banner"
        >
            <div className="w-9 h-9 rounded-xl bg-warning-soft text-warning flex items-center justify-center shrink-0">
                <AlertTriangle size={18} strokeWidth={2.6} />
            </div>
            <div className="flex-1 min-w-0">
                <div className="font-bold text-sm text-warning">
                    {pendingMakeups.length} pending make-up
                    {pendingMakeups.length === 1 ? "" : "s"}
                </div>
                <div className="text-xs text-warning/80">
                    {pendingMakeups
                        .slice(0, 2)
                        .map((r) => formatDatePretty(r.date))
                        .join(" · ")}
                    {pendingMakeups.length > 2
                        ? ` +${pendingMakeups.length - 2} more`
                        : ""}
                </div>
            </div>
            <Link
                to="/makeups"
                className="rounded-xl bg-warning hover:bg-warning/85 text-white font-bold h-10 px-4 text-sm inline-flex items-center"
                data-testid="pending-makeup-resolve-link"
            >
                Resolve
            </Link>
        </div>
    );
}
